import CircularProgress from '@material-ui/core/CircularProgress'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import ContainerBalance from 'components/ContainerBalance'
import headerImg from 'images/containers/header-containers.jpg'
import React from 'react'
import { Page, Toolbar } from 'react-onsenui'
import { appBar } from '../Styles'
const ContainersScreen = props => {
  const data = props.containerBalances

  let totalBalance = null
  let containersBalance = null
  let palletsBalance = null
  if (data && data.length) {
    totalBalance = data.reduce((total, container) => {
      return total + container.balances.reduce((subtotal, balance) => subtotal + balance.balance, 0)
    }, 0)
    containersBalance = data.reduce((total, container) => {
      return container.isPallet == true ? total : total + container.balances.reduce((subtotal, balance) => subtotal + balance.balance, 0)
    }, 0)
    palletsBalance = data.reduce((total, container) => {
      return container.isPallet == false ? total : total + container.balances.reduce((subtotal, balance) => subtotal + balance.balance, 0)
    }, 0)
  }

  return (
    <Page
      renderToolbar={() => (
        <Toolbar className={props.classes.appBar}>
          <div className="left">
            <KeyboardArrowLeftIcon onClick={() => props.goBack()} className={props.classes.goBackIcon} />
          </div>
          <div className="center">
            <Typography className={props.classes.title}>Envases</Typography>
          </div>
          <div className="right">

          </div>
        </Toolbar>
    )}>
      <div className={props.classes.header}>
        <Grid container direction="column" className={props.classes.header1}>
          <Grid item>
            <Typography className={props.classes.total}>
              {totalBalance == null ? (
                <CircularProgress color="secondary" />
              ) : (
                totalBalance.toLocaleString(undefined, { maximumFractionDigits: 2 })
              )}
            </Typography>
          </Grid>
          <Grid item>
            <Typography className={props.classes.totalBalance}><b>{containersBalance}</b> envases <b>&bull;</b> <b>{palletsBalance}</b> palets</Typography>
            <Typography className={props.classes.totalBalance} style={{ marginBottom: 10 }}>pendientes de devolver</Typography>
          </Grid>
        </Grid>
      </div>
      <Grid container className={props.classes.balances}>
        {data &&
          data.map((container, index) => (
            <ContainerBalance
              key={index}
              data={container}
            />
          ))}
      </Grid>
    </Page>
  )
}

const styles = {
  appBar,
  goBackIcon: {
    cursor: 'pointer',
    padding: 7,
    fontSize: 30,
    color: 'white',
  },
  title: {
    padding: 10,
    fontWeight: 600,
    fontSize: 17,
    color: 'white',
    textAlign: 'center',
  },
  icon: {
    fontSize: 20,
    verticalAlign: 'middle',
  },
  header: {
    backgroundImage: `url('${headerImg}')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% auto',
  },
  header1: {
    padding: 10,
  },
  total: {
    marginTop: 17,
    fontSize: 40,
    fontWeight: 'bold',
    color: 'white',
    textAlign: 'center',
  },
  totalBalance: {
    fontSize: 15,
    fontWeight: 300,
    color: 'white',
    textAlign: 'center',
  },
  balances: {},
}

export default withStyles(styles)(ContainersScreen)



// WEBPACK FOOTER //
// ./src/screens/ContainersScreen.js